(function () {
    UX.quickSearchInputs = {
        config: {
            quickSearchInputsQuery: ".quick-search__input input:not([type='hidden'])",
        },
        init: function () {
            this.set();
            this.controls();
        },
        set: function () {
            this.inputs = document.querySelectorAll(this.config.quickSearchInputsQuery);
        },
        controls: function () {
            this.inputs.forEach(input => {
                input.addEventListener('change', e => {
                    this.onChange(e);
                });
            });
        },
        updateInputsValue: function (value) {
            this.inputs.forEach(input => {
                input.value = value;
            });
        },
        onChange: function (event) {
            let value = event.target.value;
            this.updateInputsValue(value);
        },
    };
})();
